<template>
	<v-card>
		<v-card-title
			v-if="showHeader"
			class="pr-2"
		>
			<v-layout
				px-2
				row
				align-center
			>
				<slot name="header">
					<slot name="checkbox" />
				</slot>
			</v-layout>
		</v-card-title>
		<component
			:is="image ? 'v-img' : 'div'"
			:src="image"
			:style="getBackgroundColor(imageText)"
			:class="{ 'clickable': !!url }"
			class="card-img"
			height="130px"
			@click="goToUrl"
		>
			<v-progress-linear
				v-if="loading"
				indeterminate
				class="ma-0 card-loader"
			/>
			<slot name="card-hover" />
			<v-container
				fill-height
				fluid
			>
				<div
					v-if="flags.length > 0"
					class="flags-container"
				>
					<v-card
						v-for="(flag, i) in flags"
						:key="i"
						flat
						:color="flag.color"
						class="ma-1 pa-1 white--text"
					>
						<div>{{ flag.text }}</div>
					</v-card>
				</div>
				<v-layout
					fill-height
					justify-center
					align-center
					ma-0
				>
					<v-flex
						xs12
						class="text-xs-center"
					>
						<span
							v-if="!image"
							class="display-3 white--text"
						>
							{{ abbreviatedTitle }}
						</span>
					</v-flex>
				</v-layout>
			</v-container>
		</component>
		<v-card-title
			class="pt-2 pb-2"
			primary-title
		>
			<slot name="title"/>
		</v-card-title>
		<slot name="additional"/>
		<!-- <v-expansion-panel>
			<v-expansion-panel-content>
				<div slot="header">Item</div>
				<v-card-text>Lorem ipsum dolor sit amet, consecommodo consequat.</v-card-text>
			</v-expansion-panel-content>
		</v-expansion-panel> -->
		<v-divider v-if="!!this.$slots.actions"/>
		<v-card-actions v-if="!!this.$slots.actions">
			<slot name="actions"/>
		</v-card-actions>
	</v-card>
</template>

<script>
import ColorHash from 'color-hash';

export default {
	props: {
		image: { default: null, type: String },
		imageText: { default: '', type: String },
		justAdded: { default: false, type: Boolean },
		flags: { default: () => [], type: Array },
		loading: { default: false, type: Boolean },
		// Use url="emit" to get an event 'url' on image click
		url: { default: null },
	},
	data() {
		return {
			colorHash: new ColorHash(),
			showHeader: false,
		};
	},
	computed: {
		abbreviatedTitle() {
			if (!this.imageText) {
				return '';
			}
			const words = this.imageText.split(/\s+/);
			let letters = '';
			for (let i = 0; i < words.length; i++) {
				letters += words[i].charAt(0).toUpperCase();
			}
			if (letters.length > 3) {
				return letters.substring(0, 3);
			}
			return letters;
		},
	},
	created() {
		this.showHeader = !!this.$slots.header;
	},
	methods: {
		getBackgroundColor(name) {
			if (!name) {
				return '';
			}
			return `background-color: ${this.colorHash.hex(name)}`;
		},
		goToUrl() {
			if (this.loading || !this.url) {
				return;
			}
			if (this.url === 'emit') {
				this.$emit('url');
				return;
			}
			this.$router.push(this.url);
		},
	},
};
</script>

<style scoped lang="scss">
.v-icon {
	position: absolute;
	top: 0;
	right: 0;
}
.flags-container {
	position: absolute;
	top: 5px;
	bottom: 5px;
	left: 5px;
	right: 5px;
	display: flex;
	justify-content: flex-end;
	align-items: flex-start;
	flex-wrap: wrap;
	overflow: hidden;
}
.clickable {
	cursor: pointer;
}
.v-card__title {
	overflow: hidden;
}
.card-loader {
	position: absolute;
	top: 0;
}
.card-img {
	height: 130px;
	position: relative;
}
</style>
